// extracted by mini-css-extract-plugin
export default {"fieldset":"TemplateDB_fieldset__cSW8g","pdfContainer":"TemplateDB_pdfContainer__CjLbw"};